module.exports = __webpack_public_path__ + "static/media/BANNER - About_V6.f0282648.jpg";